import React, { useContext } from 'react';
import { Container, Grid } from 'semantic-ui-react';
import { LargeMonitorContext } from '../context';
import LinkTile from './LinkTile';

const InlineCtaTile = (props) => {
  const { module } = props;
  const { linkTitle, linkBodyText, image } = module;

  const largeMonitorContext = useContext(LargeMonitorContext);

  return (
    <section className="inline-cta-tile">
      <Container>
        <Grid>
          <Grid.Row>
            <Grid.Column
              largeScreen={largeMonitorContext ? 1 : 12}
            ></Grid.Column>
            <Grid.Column mobile={12} tablet={12} computer={7} largeScreen={7}>
              {image &&
                image.sourceUrl &&
                linkTitle &&
                linkTitle.url &&
                linkTitle.title && (
                  <LinkTile
                    link={linkTitle.url}
                    target={linkTitle.target}
                    icon={image.sourceUrl}
                    heading={linkTitle.title}
                    description={linkBodyText}
                  />
                )}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    </section>
  );
};

export default InlineCtaTile;
